import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { useNavigate } from "react-router";
import { AlertTemplate } from "@/components/templates/AlertTemplate";
import { AlertMessageBox } from "@/components/molecules/AlertMessageBox";
import { ReactComponent as IconGuide } from "@/styles/assets/svg/icon_guide.svg";
import { ReactComponent as IconAlert } from "@/styles/assets/svg/icon_alert_large.svg";
import { ReactComponent as IconChecked } from "@/styles/assets/svg/icon_checked_large.svg";

export const JoinDonePage = () => {
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);

  return (
    <AlertTemplate
      alert={alert}
      noticeButton={
        alert && alert === true ? (
          <Buttons
            type="button"
            size="lg"
            color="primary100"
            layout="solid"
            label="메인화면으로"
            onClick={() => navigate("/auth/login")}
          />
        ) : (
          <Buttons
            type="button"
            size="lg"
            color="white100"
            layout="solid"
            label="로그인하기"
            onClick={() => navigate("/auth/login")}
          />
        )
      }
    >
      <AlertMessageBox
        color={alert ? "white" : "colored"}
        icon={alert && alert === true ? <IconAlert /> : <IconChecked />}
        title={alert && alert === true ? "회원가입 오류" : "회원가입 완료"}
        text={
          alert && alert === true ? (
            <>
              일시적인 오류로 회원가입에 실패했습니다.
              <br />
              잠시 후 다시 시도해 주세요.
              <br />
              <br />
              계속 오류가 발생하실 경우,
              <br />
              아래 문의처로 문의 부탁드립니다.
            </>
          ) : (
            <>회원가입이 성공적으로 완료되었습니다.</>
          )
        }
      >
        {alert && alert === true ? (
          <>
            <span>
              <IconGuide />
              가입 오류 문의
            </span>
            000-000-0000
          </>
        ) : undefined}
      </AlertMessageBox>
    </AlertTemplate>
  );
};
